import i18n from 'i18next'
import HttpApi from 'i18next-http-backend'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
//import { i18n as i18nOtherLib } from '@sistemiv/s-components'

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .use(detector)
  .init({
    lng: localStorage.getItem('lng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          openBpmn: 'Open BPMN Modeler',
          openForm: 'Open Form Modeler',
          openDMN: 'Open DMN Modeler',
          profile: 'Profile',
          logout: 'Logout',
          upload: 'Upload',
          export: 'Download',
          noProjects: 'No projects',
          projects: 'Projects',
          project: 'Project',
          cancel: 'Cancel',
          create: 'Create',
          addProject: 'New project',
          name: 'Name',
          rename: 'Rename',
          duplicate: 'Duplicate',
          getLink: 'Get link',
          download: 'Download',
          preview: 'Preview',
          documentation: 'Documentation',
          backToEditor: 'Back to editor',
          modified: 'Modified',
          size: 'Size',
          actions: 'Actions',
          delete: 'Delete',
          deleteProjectMsg: 'Are you sure you want to delete this project?',
          deleteBulkProjectMsg: 'Are you sure you want to delete these projects?',
          deleteBulkFilesMsg: 'Are you sure you want to delete these files?',
          deleteProject: 'Delete project',
          renameProject: 'Rename project',
          copiedMsg: 'Project link copied!',
          noFiles: 'No files',
          folder: 'Folder',
          newFolder: 'New folder',
          renameFolder: 'Rename folder',
          renameFile: 'Rename file',
          moveTo: 'Move to',
          save: 'Save',
          replace: 'Upload to replace',
          uploadToReplaceMsg: 'Are you sure you want to replace this file?',
          deleteFolderMsg: 'Are you sure you want to delete this directory?',
          deleteFolder: 'Delete directory',
          deleteFileMsg: 'Are you sure you want to delete this file?',
          deleteFile: 'Delete file',
          nothingFound: 'No results',
          search: 'Search',
          continue: 'Continue',
          warning: 'Warning',
          saveFileWarningMsg:
            'A file with the same name already exists. If you continue, the existing file will be replaced. To create a new file, please rename it.',
          logInFromOtherAcc: 'Log in from another account',
          goBack: 'Go back',
          notAuthorized: "You're not authorized to access this page",
        },
      },
      sr: {
        translation: {
          openBpmn: 'Otvori BPMN Modeler',
          openForm: 'Otvori Form Modeler',
          openDMN: 'Otvori DMN Modeler',
          profile: 'Profil',
          logout: 'Odjavi se',
          upload: 'Okači',
          export: 'Preuzmi',
          noProjects: 'Nema projekata',
          projects: 'Projekti',
          project: 'Projekat',
          cancel: 'Otkaži',
          create: 'Kreiraj',
          addProject: 'Novi projekat',
          name: 'Ime',
          rename: 'Preimenuj',
          duplicate: 'Dupliraj',
          getLink: 'Kopiraj putanju',
          download: 'Preuzmi',
          preview: 'Prikaži',
          documentation: 'Dokumentacija',
          backToEditor: 'Nazad u editor',
          modified: 'izmenjeno',
          size: 'Veličina',
          actions: 'Akcije',
          delete: 'Obriši',
          deleteProjectMsg: 'Da li ste sigurni da želite da obrišete ovaj projekat?',
          deleteBulkProjectMsg: 'Da li ste sigurni da želite da obrišete ove projekte?',
          deleteBulkFilesMsg: 'Da li ste sigurni da želite da obrišete ove daoteke?',
          deleteProject: 'Obriši projekat',
          renameProject: 'Preimenuj projekat',
          copiedMsg: 'Uspešno kopirana putanja do projekta!',
          noFiles: 'Nema fajlova',
          folder: 'Folder',
          newFolder: 'Novi folder',
          renameFolder: 'Preimenuj folder',
          renameFile: 'Preimenuj fajl',
          moveTo: 'Premesti',
          save: 'Sačuvaj',
          replace: 'Zameni novim fajlom',
          deleteFolderMsg: 'Da li ste sigurni da želite da obrišete ovaj folder?',
          deleteFolder: 'Obriši folder',
          deleteFileMsg: 'Da li ste sigurni da želite da obrišete ovaj fajl?',
          deleteFile: 'Obriši fajl',
          nothingFound: 'Nema rezultata',
          search: 'Pretraži',
          warning: 'Upozorenje',
          saveFileWarningMsg:
            'Fajl sa istim imenom već postoji. Ako nastavite, postojeći fajl će biti zamenjen. Da biste sačuvali novi fajl, molimo vas da ga preimenujete.',
          logInFromOtherAcc: 'Prijavite se sa drugog naloga',
          goBack: 'Vratite se unazad',
          notAuthorized: 'Nemate ovlašćenje za pristup ovoj stranici',
        },
      },
    },
  })

// i18n.on('languageChanged', (lng) => {
//   i18nOtherLib.changeLanguage(lng)
// })

export default i18n
